import { SETTINGS_TABS, SettingTabNames } from "./settings.constants";

export const getSettingsTab = (tabName: SettingTabNames) =>
  SETTINGS_TABS.find((tab) => tab.name === tabName);
